import React from 'react';

import type { FieldNameProp } from '@swf/core/types/Props';
import type { TrackedTranslation } from '@swf/core/types/i18n';
import {
  NAME_AND_CITY_NOT_ALLOWED_SYMBOLS,
  minLength as minLengthFactory,
  mustNotContainNumber,
  mustNotContainSymbols,
  noWhiteStartOrEnd,
  required
} from '@swf/core/utils/validators';
import type { Error } from '@swf/core/utils/validators';

import TextInput from '../TextInput/TextInput';

import {
  TXTCLI_City,
  TXTWCL_Please_enter_your_cityX,
  TXTWCL_Please_try_againX_This_must_be_ELL,
  TXTWCL_The_city_you_have_entered_is_i_ELL_1
} from './City.messages.json';

interface Props extends FieldNameProp {
  requiredMessage?: Error['message'];
  value?: string;
  label?: TrackedTranslation;
  className?: string;
}

const maxLength = 60;
const minLength = 2;

const City: React.FC<Props> = ({
  fieldName,
  requiredMessage = TXTWCL_Please_enter_your_cityX,
  value,
  label = TXTCLI_City,
  className
}) => (
  <TextInput
    id={fieldName}
    label={label}
    maxLength={maxLength}
    autoComplete="off"
    value={value}
    className={className}
    checkDisabled
    validators={[
      noWhiteStartOrEnd,
      required(requiredMessage),
      minLengthFactory(minLength, {
        ...TXTWCL_Please_try_againX_This_must_be_ELL,
        values: { 0: minLength }
      }),
      mustNotContainSymbols(
        NAME_AND_CITY_NOT_ALLOWED_SYMBOLS,
        TXTWCL_The_city_you_have_entered_is_i_ELL_1
      ),
      mustNotContainNumber(TXTWCL_The_city_you_have_entered_is_i_ELL_1)
    ]}
  />
);

export default City;
